module.exports = __webpack_public_path__ + "media/images/proof_links/colored/vine-dcceb8e4e344c907bae5b91262ef673d.svg";